import { useCallback, useContext, useEffect, useState } from "react";
import Offer from "../../components/offers/Offer";
import {
  Col,
  Container,
  Form,
  FormControl,
  InputGroup,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import Cookies from "universal-cookie";
import "./offers.css";

import Skeleton from "../../components/skeletons/Skeleton";
import { OffersContext } from "../../context/offers/OffersContext";
import { TenantContext } from "../../context/tenant/TenantContext";
import { LanguageContext } from "../../context/language/LanguageContext";
import { useRef } from "react";
import { ClientContext } from "../../context/client/ClientContext";
import { Link, useParams, useSearchParams } from "react-router-dom";
import Banner from "../../components/Banner/Banner";
import { CategoriesContext } from "../../context/categories/CategoriesContext";
import { offerwallapi } from "../../config/axiosconfig";
import { CardContext } from "../../context/card/CardContext";
import DOMPurify from "dompurify";
import { isMobile } from "react-device-detect";

export default function Offers() {
  const { client } = useContext(ClientContext);
  const { tenant } = useContext(TenantContext);
  const { offers, offersdispatch } = useContext(OffersContext);
  const { categories, categoriesdispatch } = useContext(CategoriesContext);
  const { card, carddispatch } = useContext(CardContext);

  const [offerslist, setOffersList] = useState([]);
  const { language } = useContext(LanguageContext);
  const cboxFilter = useRef();
  const cboxMyCards = useRef();

  const [loader, setLoader] = useState(true);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [message, setMessage] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const params = useParams();

  const [campains, setCampaigns] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();


  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const [displayDate, setDisplayDate] = useState("");
  const [cdDays, setCdDays] = useState("00");
  const [cdHours, setCdHours] = useState("00");
  const [cdMinutes, setCdMinutes] = useState("00");
  const [cdSeconds, setCdSeconds] = useState("00");
  const [firstExp, setFirstExp] = useState(null);
  const [loadingWithCard, setLoadingWithCard] = useState(false);

  const closeMessageModal = () => {
    setShowMessageModal(false);
  };

  const getCampains = async () => {
    const res = await offerwallapi.get("/api/gamification/get-campaigns", {
      params: { tenantid: tenant.tenantid, clientid: client.clientid },
    });
    if (res && res.data) {
      setCampaigns(res.data);

      setTimeout(() => {
        if (res.data.length > 1)
          document.getElementById("btnNextCampaign").click();
      }, 3000);
    }
  };

  useEffect(() => {
    // if(offers){
    //   console.log("offers from context", offers)
    // }
    if (tenant && client) getCampains();
  }, [tenant, client]);

  const orderOffers = (off) => {
    let orderby = cboxFilter.current.value; //event.target.value;
    setLoader(true);
    let filteredOffers = off && Array.isArray(off) ? [...off] : [...offerslist];
    if (orderby === "latest") {
      filteredOffers.sort((a, b) => {
        const aPublished = new Date(a.published);
        const bPublished = new Date(b.published);

        return bPublished.getTime() - aPublished.getTime();
      });
    } else if (orderby === "endingsoon") {
      // console.log("ending soon");
      filteredOffers.sort((a, b) => {
        const aValidTo = a.validToUTC
          ? new Date(a.validToUTC).getTime()
          : new Date().setDate(100000);
        const bValidTo = b.validToUTC
          ? new Date(b.validToUTC).getTime()
          : new Date().setDate(100000);
        return aValidTo - bValidTo;
      });
    } else if (orderby === "popularity") {
      // console.log("popular");

      filteredOffers.sort((a, b) => {
        let aRedemptions = a.totalRedemptions || 0;
        let bRedemptions = b.totalRedemptions || 0;

        return bRedemptions - aRedemptions;
      });
    }

    setOffersList(filteredOffers);
    setLoader(false);
  };

  const filterOffers = (event) => {
    let filterby = event.target.value;
    var filteredOffers = [];
    for (var i = 0, j = offers; i < j.length; i++) {
      if (
        j[i].title.toLowerCase().includes(filterby.toLowerCase()) ||
        j[i].mName.toLowerCase().includes(filterby.toLowerCase())
      ) {
        filteredOffers.push(j[i]);
      }
    }
    setOffersList(filteredOffers);
  };

  const setCategoriesList = (category) => {
    // console.log(category)
    let cats = [...categoryList];

    const boxes = document.querySelectorAll(".category");

    boxes.forEach((box) => {
      box.classList.remove("catactive");
    });
    if (category.catalias === "all") {
      // console.log("CATTTTTTT all", category)
      cats = [];
    } else {
      // console.log("CATTTTTTT otehr", category)
      let catindex;
      let catexist = false;
      for (var i = 0, j = cats.length; i < j; i++) {
        if (cats[i].category === category.category) {
          catindex = i;
          catexist = true;
        }
      }
      if (catexist) {
        cats.splice(catindex, 1);
      } else {
        cats.push(category);
      }
      // if (cats.indexOf(category.catalias) > -1) {

      //     cats.splice(cats.indexOf(category.category), 1);

      // } else {

      //     cats.push(category)

      // }
    }

    if (cats.length === 0) {
      const catItem = document.getElementById("catall");
      catItem.classList.add("catactive");
    } else {
      cats.map((thiscat, index) => {
        // console.log("this cat", thiscat)
        const catItem = document.getElementById(
          `cat${thiscat.category.split("/").join("").split(" ").join("")}`
        );
        catItem.classList.add("catactive");
      });
    }

    setCategoryList(cats);
    categoryFilter(cats);
  };

  const categoryFilter = (cats) => {
    //let filterby = event.target.value;
    var filteredOffers = [];
    setLoader(true);
    let ordersOffers = [...offers];
    if (cats.length > 0) {
      for (var i = 0, j = ordersOffers; i < j.length; i++) {
        for (var k = 0, l = cats; k < l.length; k++) {
          if (l[k].category === j[i].targetMerchants[0].category.name) {
            filteredOffers.push(j[i]);
          }
        }
        // if (cats.cattegory.indexOf(j[i].targetMerchants[0].category.name) > -1) {

        // }
        // if (j[i].category.toLowerCase().includes(filterby.toLowerCase()) ||
        //     j[i].mName.toLowerCase().includes(filterby.toLowerCase())) {
        //     filteredOffers.push(j[i]);
        // }
      }
    } else {
      filteredOffers = [...ordersOffers];
    }

    setOffersList(filteredOffers);
    orderOffers(filteredOffers);
    setLoader(false);
  };

  useEffect(() => {
    if (offers && offers.length > 0) {
      setCategoriesList({ category: "all", catalias: "all" });
      // setOffersList(offers);
      //  orderOffers();
    }
  }, [offers]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!params.searchtext) {
      document.getElementById("txtGlobalSearch").value = "";
    }

    const cookies = new Cookies();
    let dtn = new Date();
    const sparams = searchParams.get("ref")
    console.log("paramsssss :", params, sparams)
    if (sparams) {
      cookies.set("campaign_ref", DOMPurify.sanitize(sparams), {
        path: "/",
        expires: new Date(dtn.setMinutes(dtn.getMinutes() + 15)),
        secure: true,
        domain: ".offers-exchange.com",
      })
    }

  }, []);

  const getOffers = useCallback(
    async (lancode) => {
      const cardnumber = cboxMyCards.current ? cboxMyCards.current.value : "";
      if (!cardnumber && offers) {
        setOffersList(offers);
        orderOffers(offers);
        return;
      }
      if (cardnumber) {
        setLoadingWithCard(true);
      }
      setOffersList([]);
      offersdispatch({ type: "OFFERS_START" });
      try {
        const res = await offerwallapi.get("/api/offers", {
          params: {
            tenantid: tenant.tenantid,
            languagecode: lancode, // language ? language.languagecode : "en",
            cardnumber: cardnumber,
          },
        });
        //res.data.tenantid = tenant.tenantid;
        // offersdispatch({ type: "OFFERS_START" });
        const catList = [];
        // console.log(res.data.offers)
        for (const item of res.data.offers) {
          if (item.targetMerchants.length > 0) {
            // console.log(" : ", item.targetMerchants[0]?.category?.name)
            if (catList.indexOf(item.targetMerchants[0]?.category?.name) === -1) {
              catList.push(item.targetMerchants[0].category.name);
            }
          }
        }
        // console.log("SET STATES CAT AND OFFERS");
        categoriesdispatch({ type: "CATEGORIES_SUCCESS", payload: catList });
        offersdispatch({ type: "OFFERS_SUCCESS", payload: res.data.offers });
      } catch (err) {
        offersdispatch({ type: "OFFERS_FAIL", payload: err });
      } finally {
        if (cardnumber) {
          setLoadingWithCard(false);
        }
      }
    },
    [tenant, language, offersdispatch, categoriesdispatch, cboxMyCards]
  );
  useEffect(() => {
    // console.log("card", card?.length);
    if (tenant && language) {
      getOffers(language?.languagecode);
    }
  }, [tenant, client, language, card]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const camapignExpiry = tenant?.tenantmasterconfig?.campaign_expiry;

        // for testing purposes
        // const utcDateTime = new Date();
        // utcDateTime.setDate(utcDateTime.getDate() + 10);
        // utcDateTime.setUTCHours(0, 0, 0, 0);
        // setFirstExp(utcDateTime);
        // setCountDown(utcDateTime);
        // console.log('datetostring', utcDateTime);
        // const utcDateTime = new Date();
        // utcDateTime.setMinutes(utcDateTime.getMinutes() + 100);
        // console.log('datetostring', camapignExpiry);

        setFirstExp(camapignExpiry);
        setCountDown(camapignExpiry);
        setLoader(false);
      } catch (error) {
        setLoader(false);
      }
    };

    if (tenant) {
      fetchData();
    }
  }, [tenant]);

  const curDatetime = new Date();
  const currentDate = new Date(curDatetime.toUTCString());
  const expiryDate = new Date(firstExp);
  const timeDifference = expiryDate - currentDate;
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const showCountdownThreshold = 10;

  const getDateSuffix = (i) => {
    let j = i % 10,
      k = i % 100;
    if (j === 1 && k !== 11) {
      return i + "st";
    }
    if (j === 2 && k !== 12) {
      return i + "nd";
    }
    if (j === 3 && k !== 13) {
      return i + "rd";
    }
    return i + "th";
  };

  const getTimewithAMPM = (hours, minute) => {
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${hours < 10 ? "0" + hours : hours}.${minute < 10 ? "0" + minute : minute
      }${ampm}`;
  };

  const setCountDown = (datetime) => {
    const dDate = new Date(datetime);
    const d = dDate.getTime();
    const mon = months[dDate.getMonth()];
    const day = dDate.getDate();
    const hour = dDate.getHours();
    const year = dDate.getFullYear();
    const minute = dDate.getMinutes();
    // console.log(date, dDate, mon, day, hour, year, minute)
    const displayD = `${mon} ${getDateSuffix(day)} ${year} at ${getTimewithAMPM(
      hour,
      minute
    )} AEST`;
    setDisplayDate(displayD);

    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = d - now;
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      days = days < 0 ? "0" : days;
      hours = hours < 0 ? "0" : hours;
      minutes = minutes < 0 ? "0" : minutes;
      seconds = seconds < 0 ? "0" : seconds;

      setCdDays(days < 10 ? "0" + days : days);
      setCdHours(hours < 10 ? "0" + hours : hours);
      setCdMinutes(minutes < 10 ? "0" + minutes : minutes);
      setCdSeconds(seconds < 10 ? "0" + seconds : seconds);
      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        setFirstExp(null);
        // document.getElementById("demo").innerHTML = "EXPIRED";
      }
    }, 1000);
  };

  return (
    <div>
      <Banner />
      <div>
        {firstExp && daysDifference <= showCountdownThreshold ? (
          <div
            id="divCountDownSection container"
            className="text-center"
            style={{ backgroundColor: "#FCC015", padding: "10px 10px" }}
          >
            <h3
              className="fw-bold d-inline-block fs-14"
              style={{ verticalAlign: "text-bottom", marginBottom: "5px" }}
            >
              {language?.static_labels.countdown_title}
            </h3>

            <div className="d-inline-block" style={{ verticalAlign: "middle" }}>
              <div
                className="giveaway-time-box"
                style={{ color: "#826000", fontSize: "10px" }}
              >
                <div className="fs-18" style={{ backgroundColor: "#FFD14F" }}>
                  {cdDays}
                </div>
                {language?.static_labels.countdown_title_days}
              </div>

              <div
                className="giveaway-time-box"
                style={{ color: "#826000", fontSize: "10px" }}
              >
                <div className="fs-18" style={{ backgroundColor: "#FFD14F" }}>
                  {cdHours}
                </div>
                {language?.static_labels.countdown_title_hours}
              </div>

              <div
                className="giveaway-time-box"
                style={{ color: "#826000", fontSize: "10px" }}
              >
                <div className="fs-18" style={{ backgroundColor: "#FFD14F" }}>
                  {cdMinutes}
                </div>
                {language?.static_labels.countdown_title_minutes}
              </div>

              <div
                className="giveaway-time-box"
                style={{ color: "#826000", fontSize: "10px" }}
              >
                <div className="fs-18" style={{ backgroundColor: "#FFD14F" }}>
                  {cdSeconds}
                </div>
                {language?.static_labels.countdown_title_seconds}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {card?.length > 0 ? (
        <div className="container mt-4">
          <div className="selector">
            <select
              ref={cboxMyCards}
              className="form-select rounded-with-no-border"
              aria-label="Default select example"
              onChange={() => getOffers(language?.languagecode)}
              style={{ width: "125px" }}
            >
              {card?.map((crd, index) => {
                return (
                  <option key={crd.cardnumber || index} value={crd.cardnumber}>
                    {(crd.cardalias) ? crd.cardalias : crd.last4digits}
                  </option>
                );
              })}
            </select>
          </div>
          <label
            style={{ float: "right", lineHeight: "28px", fontSize: "14px" }}
            className="d-inline-block me-2"
          >
            {language?.static_labels.offermycards}:
          </label>
        </div>
      ) : (
        ""
      )}
      <section
        className="brand_area pt-4 pt-md-5 pb-50 wow fadeIn"
        data-wow-duration="2s"
        data-wow-delay="0.5s"
      >
        <div className="container">
          <div className="section_title">
            <h4
              className="sub_title offer_mobile_title_fs"
              style={{ fontSize: "16px" }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(tenant?.tenantcontentconfig?.home?.welcome_note,
                  { ADD_ATTR: ['target', 'class'] })
              }}
            ></h4>
          </div>

          <div className="catmaincontainer" style={{ display: "none" }}>
            <div className="categoryContainer">
              <div
                id="catall"
                className="d-inline-block category"
                onClick={() => {
                  setCategoriesList({ category: "all", catalias: "all" });
                }}
              >
                <div className="grid-icon mb-2">
                  <img
                    alt="All"
                    src={`${process.env.REACT_APP_CLOUDFRONT
                      }categories/${DOMPurify.sanitize(
                        params.tenanturlpathname
                      )}/All.svg`}
                  />
                </div>
                <div className="grid-label">{language?.static_labels.all}</div>
              </div>

              {categories && language ? (
                categories?.map((cat, index) => {
                  for (let i = 0, j = language?.categories; i < j.length; i++) {
                    if (j[i].category === cat) {
                      return (
                        <div
                          id={`cat${cat
                            .split("/")
                            .join("")
                            .split(" ")
                            .join("")}`}
                          className="d-inline-block category"
                          key={index}
                          onClick={() => {
                            setCategoriesList(j[i]);
                          }}
                        >
                          <div className="grid-icon mb-2">
                            <img
                              alt={j[i].catalias}
                              src={`${process.env.REACT_APP_CLOUDFRONT
                                }categories/${DOMPurify.sanitize(
                                  params.tenanturlpathname
                                )}/${cat.split("/").join("")}.svg`}
                            />
                          </div>
                          <div className="grid-label">{j[i].catalias}</div>
                        </div>
                      );
                    }
                  }
                })
              ) : (
                <Skeleton type="category" count="7" />
              )}
            </div>
          </div>
          <div className="mt-2">
            {categoryList?.map((catName, index) => {
              return (
                <span class="badge text-bg-secondary me-2" key={index}>
                  {catName.catalias}
                  <button
                    type="button"
                    class="btn-close ms-2 text-white"
                    aria-label="Close"
                    style={{ verticalAlign: "text-top" }}
                    onClick={() => {
                      setCategoriesList(catName);
                    }}
                  ></button>
                </span>
              );
            })}
          </div>
        </div>
      </section>

      {client && campains.length > 0 ? (
        <section>
          <div className="container">
            <h4 className="offer_mobile_title_fs offer_mobile_banner_title">
              {language?.static_labels.gamification_banners_header}
            </h4>
            <div
              id="carouselAutoplayingCampaign"
              className="carousel slide mb-3"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                {campains.map((val, index) => (
                  <div
                    key={val.campaign_id || index}
                    className={`carousel-item ${index === 0 ? "active" : ""}`}
                  >
                    <div className="row">
                      <Link
                        to={`/${params.tenanturlpathname}/gamification`}
                        state={{ campaignId: val.campaign_id }}
                      >
                        {isMobile ? (
                          <img
                            width={"100%"}
                            src={DOMPurify.sanitize(
                              val.campaign_config[
                              `mobile-spin-banner-${language?.languagecode}`
                              ]
                            )}
                            alt="spinning banner"
                          />
                        ) : (
                          <img
                            width={"100%"}
                            src={DOMPurify.sanitize(
                              val.campaign_config[
                              `spin-banner-${language?.languagecode}`
                              ]
                            )}
                            alt="spinning banner"
                          />
                        )}
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
              {campains.length > 1 && (
                <>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselAutoplayingCampaign"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon offer-campaign-carousel"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselAutoplayingCampaign"
                    data-bs-slide="next"
                    id="btnNextCampaign"
                  >
                    <span
                      className="carousel-control-next-icon offer-campaign-carousel"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </>
              )}
            </div>
          </div>
        </section>
      ) : null}

      <section className="features_area mb-5">
        <div className="container">
          <div
            className="section_title pb-30 wow fadeIn"
            data-wow-duration="2s"
            data-wow-delay="0.5s"
          >
            <h4 className="sub_title d-inline-block">
              {language?.static_labels.popular_offers}
            </h4>
            <div className=" d-inline-block" style={{ float: "right" }}>
              <div className="selector">
                <select
                  ref={cboxFilter}
                  className="form-select rounded-with-no-border"
                  aria-label="Default select example"
                  onChange={orderOffers}
                  style={{ width: "125px" }}
                  defaultValue="latest"
                >
                  <option value="latest">
                    {language?.static_labels.latest}
                  </option>
                  <option value="endingsoon">
                    {language?.static_labels.ending_soon}
                  </option>
                  <option value="popularity">
                    {language?.static_labels.popularity}
                  </option>
                </select>
              </div>
              <label
                style={{ float: "right", lineHeight: "28px", fontSize: "14px" }}
                className="d-none d-md-inline-block me-2"
              >
                {language?.static_labels.offers_sort_by}:
              </label>
            </div>
          </div>

          <div className="row g-4" data-wow-duration="2s" data-wow-delay="0.5s">
            {!offers ? (
              <Skeleton type="offer" count="8" />
            ) : offerslist.length > 0 ? (
              offerslist?.map((offer) => {
                if (
                  (offer.remainingActivations === -1 &&
                    offer.activationStatus) ||
                  offer.activationStatus !== "Expired" ||
                  (offer.activationStatus === "Expired" &&
                    offer.remainingActivations > 0)
                )
                  return (
                    <Offer
                      offer={offer}
                      key={offer.id}
                      loadingWithCard={loadingWithCard}
                    />
                  );
              })
            ) : (
              <div className="text-center mt-4">
                <h2>{language?.static_labels.nooffers}</h2>
              </div>
            )}
          </div>
        </div>
      </section>
      {loader ? (
        <div className="ow-full-overlay">
          <div className="position-absolute ow-content-center text-center">
            <Spinner animation="border" backdrop="static" variant="light" />
            <h3 className="text-light">{message}</h3>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
